// extracted by mini-css-extract-plugin
export default {"ChangePassword":"changePassword_ChangePassword__CPwD-"};